import { styled, TableCell } from '@mui/material';

export const NestedTableCell = styled(TableCell)(() => ({
  fontWeight: 700,
  fontSize: '17px'
}));
